import React from 'react';
import { palette } from '../styles/Palette';

const ChatPlus = ({ width = "16", height = "16", color = palette.gray500, ...props }) => {
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg"
      width={width} 
      height={height} 
      viewBox="0 0 16 16" 
      fill="none" 
      {...props}
    >
    <path 
      fill-rule="evenodd" 
      clip-rule="evenodd" 
      d="M1 8C1 4.134 4.134 1 8 1C11.866 1 15 4.134 15 8C15 11.866 11.866 15 8 15H1V8ZM8 0C3.58172 0 0 3.58172 0 8V16H8C12.4182 16 16 12.4182 16 8C16 3.58172 12.4182 0 8 0ZM4.21533 8.00441C4.21533 7.73059 4.4373 7.50863 4.71112 7.50863H7.9918V4.20953C7.9918 3.93572 8.21377 3.71375 8.48759 3.71375C8.76141 3.71375 8.98338 3.93572 8.98338 4.20953V7.50863H12.2836C12.5574 7.50863 12.7794 7.73059 12.7794 8.00441C12.7794 8.27823 12.5574 8.50021 12.2836 8.50021H8.98338V11.782C8.98338 12.0558 8.76141 12.2777 8.48759 12.2777C8.21377 12.2777 7.9918 12.0558 7.9918 11.782V8.50021H4.71112C4.4373 8.50021 4.21533 8.27823 4.21533 8.00441Z" 
      fill={color}
    />
    </svg>
  );
};

export default ChatPlus; 